import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface LocationState {
  fromLocation?: string | null;
}

const initialState: LocationState = {
  fromLocation: null,
};

const locationStateSlice = createSlice({
  name: "locationState",
  initialState,
  reducers: {
    setFromLocation(state, action: PayloadAction<string>) {
      state.fromLocation = action.payload;
      // Also store in localStorage for persistence across page refreshes
      localStorage.setItem("fromLocation", action.payload);
    },
    clearFromLocation(state) {
      state.fromLocation = null;
      localStorage.removeItem("fromLocation");
    },
  },
});

export const { setFromLocation, clearFromLocation } = locationStateSlice.actions;
export default locationStateSlice.reducer;
